/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from "react";
import clsx from "clsx";
import { Image } from "react-bootstrap";
import HotJobIconChip from "src/imagesV2/HotJobIconChip.svg";
import styles from "./JobCardChip.module.scss";

export interface JobCardChipProps {
  type: "exclusive" | "hot-job" | "new";
  size?: "normal" | "compact";
  className?: string;
}

const JobCardChip = ({
  type,
  size,
  className
}: JobCardChipProps) => {
  let label: ReactNode;
  let typeClassName: string;

  switch (type) {
    case "exclusive":
      label = "Exclusive";
      typeClassName = styles.exclusive;
      break;
    case "hot-job":
      label = (<div className={styles.hotJobLabel}>
        <Image src={HotJobIconChip} className={styles.hotJobChipIcon} />
        <span>Hot Job</span>
      </div>);
      typeClassName = styles.hotJob;
      break;
    case "new":
      label = "New";
      typeClassName = styles.new;
      break;
    default:
      label = "";
      typeClassName = "";
      break;
  }

  return (
    <div className={clsx(
      styles.main,
      size === "compact" && styles.compact,
      typeClassName,
      className
    )}>
      {label}
    </div>
  );
}

JobCardChip.defaultProps = {
  size: "normal",
  className: ""
};

export default JobCardChip;
